import { useState, useEffect } from "react";
import axios from "axios";
import API_ENDPOINTS from "config/api";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 React example components
import DataTable from "examples/Tables/DataTable";

export default function Asistencias() {
  const [fecha, setFecha] = useState("2024-11-25");

  const [asistencias, setAsistencias] = useState([]);

  useEffect(() => {
    const fetchAsistencias = async () => {
      try {
        const response = await axios.get(API_ENDPOINTS.RRHH.ASISTENCIAS, {
          params: { fecha },
        });
        setAsistencias(response.data);
      } catch (error) {
        console.error("Error al cargar asistencias:", error);
      }
    };
    fetchAsistencias();
  }, [fecha]);

  const getEstatusColor = (estatus) => {
    switch (estatus) {
      case "Presente":
        return "success";
      case "Retardo":
        return "warning";
      case "Falta":
        return "error";
      case "Salida Temprana":
        return "info";
      default:
        return "default";
    }
  };

  const columns = [
    {
      Header: "No. Empleado",
      accessor: "numEmpleado",
      width: "15%",
    },
    {
      Header: "empleado",
      accessor: "empleado",
      width: "30%",
    },
    {
      Header: "entrada",
      accessor: "entrada",
      width: "12%",
    },
    {
      Header: "salida",
      accessor: "salida",
      width: "12%",
    },
    {
      Header: "horas",
      accessor: "horas",
      width: "10%",
    },
    {
      Header: "estatus",
      accessor: "estatus",
      width: "15%",
    },
  ];

  const rows = asistencias.map((item) => ({
    numEmpleado: (
      <MDTypography variant="caption" fontWeight="medium">
        {item.numEmpleado}
      </MDTypography>
    ),
    empleado: <MDTypography variant="caption">{item.empleado}</MDTypography>,
    entrada: <MDTypography variant="caption">{item.entrada}</MDTypography>,
    salida: <MDTypography variant="caption">{item.salida}</MDTypography>,
    horas: (
      <MDTypography variant="caption" fontWeight="medium">
        {item.horas} hrs
      </MDTypography>
    ),
    estatus: (
      <MDBox>
        <MDTypography variant="caption" color={getEstatusColor(item.estatus)} fontWeight="bold">
          {item.estatus}
        </MDTypography>
      </MDBox>
    ),
  }));

  return (
    <MDBox>
      <Card>
        <MDBox p={3}>
          <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={3}>
            <MDTypography variant="h6" fontWeight="medium">
              Control de Asistencias
            </MDTypography>
            <MDBox display="flex" gap={2}>
              <TextField
                type="date"
                label="Fecha"
                value={fecha}
                onChange={(e) => setFecha(e.target.value)}
                InputLabelProps={{ shrink: true }}
                size="small"
              />
              <MDButton variant="gradient" color="info">
                <Icon>file_download</Icon>&nbsp;Exportar
              </MDButton>
            </MDBox>
          </MDBox>

          <Grid container spacing={2} mb={3}>
            <Grid item xs={6} md={3}>
              <MDBox textAlign="center" p={2} sx={{ bgcolor: "success.lighter", borderRadius: 2 }}>
                <MDTypography variant="caption">Presentes</MDTypography>
                <MDTypography variant="h4" color="success">
                  2
                </MDTypography>
              </MDBox>
            </Grid>
            <Grid item xs={6} md={3}>
              <MDBox textAlign="center" p={2} sx={{ bgcolor: "warning.lighter", borderRadius: 2 }}>
                <MDTypography variant="caption">Retardos</MDTypography>
                <MDTypography variant="h4" color="warning">
                  1
                </MDTypography>
              </MDBox>
            </Grid>
            <Grid item xs={6} md={3}>
              <MDBox textAlign="center" p={2} sx={{ bgcolor: "error.lighter", borderRadius: 2 }}>
                <MDTypography variant="caption">Faltas</MDTypography>
                <MDTypography variant="h4" color="error">
                  1
                </MDTypography>
              </MDBox>
            </Grid>
            <Grid item xs={6} md={3}>
              <MDBox textAlign="center" p={2} sx={{ bgcolor: "info.lighter", borderRadius: 2 }}>
                <MDTypography variant="caption">Otros</MDTypography>
                <MDTypography variant="h4" color="info">
                  1
                </MDTypography>
              </MDBox>
            </Grid>
          </Grid>

          <DataTable
            table={{ columns, rows }}
            showTotalEntries={false}
            isSorted={false}
            noEndBorder
          />
        </MDBox>
      </Card>
    </MDBox>
  );
}
